module.exports = {
	"articleTitle1": "Rick's",
	"catImage": "yellowstar.png",
	"totalCats": 1,
	"name": "Rick's American Cafe",
	"articleLink1": "https://www.michigandaily.com/article/ricks-lead",
	"articleLink2": "https://www.michigandaily.com/section/arts/boaa-ricks-american-cafe",
	"articleSnippet1": "Nov 5, 2013 ... We went to Rick's, not looking for love, but searching for an explanation for the ... '\nTil Rick's do us part: A drunk history of Rick's American Cafe ...",
	"articleSnippet2": "Mar 30, 2017 ... Rick's American Cafe is absurd, and I mean this in the absolute best way \npossible. When you descend into the basement establishment, you ...",
	"foodRecommendations": [],
	"articleTitle2": "Best Dance Club: Rick's American Cafe ",
	"address": "611 Church St, Ann Arbor, MI 48104",
	"images": [
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/large/public/170406/smk.BOAA_.CharleysRicksPizzaHouseSadako.4.6.17186.jpg?itok=j1TF-_PI",
			"author": "Sindu Kilaru",
			"caption": ""
		}
	],
	"position": {
		"lat": 42.274448,
		"lng": -83.733926
	},
	"totalMisc": 1,
	"categories": {
		"nightlife": 1,
		"bestofaa": 1,
		"location": 1,
		"entertainment": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/ricks.json
// module id = 961
// module chunks = 0